import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {add, fetch} from '../services/ReportRunsService';
import {ReportRun} from '../types';
import {notifyError, notifySuccess} from '../../../components/ServiceNotifications';

export const useReportRun = (reportRunId?: string) => {
    const queryClient = useQueryClient();

    const reportRunQuery = useQuery({
        queryKey: ['reportRun', reportRunId],
        queryFn: () => fetch(reportRunId!),
        enabled: !!reportRunId,
    });

    const createMutation = useMutation({
        mutationFn: (values: ReportRun) => {
            const payload = {...values} as Record<string, unknown>;
            delete payload.id;
            delete payload.created;
            delete payload.succeededAt;
            return add(payload as ReportRun);
        },
        onSuccess: () => {
            notifySuccess('Report run created');
            queryClient.invalidateQueries({queryKey: ['reportRuns']});
        },
        onError: notifyError,
    });

    return {
        record: reportRunQuery.data,
        loading: reportRunQuery.isLoading,
        fetchRecord: reportRunQuery.refetch,
        createRecord: createMutation.mutate,
        createMutation,
    };
};
